import { queryOptions } from "@tanstack/react-query";
import { api, unwrap } from "@/client/lib/api";
import type { Holiday, Schedule } from "@/shared/schedule";

// Shared by attendance and the settings screens that set them, so they live outside both features.
export const scheduleQuery = queryOptions({
  queryKey: ["schedule"],
  queryFn: (): Promise<Schedule> => unwrap(api.schedule.$get()),
});

// Holidays and working Saturdays together.
export const holidaysQuery = (year: number) =>
  queryOptions({
    queryKey: ["holidays", year],
    queryFn: (): Promise<Holiday[]> =>
      unwrap(api.holidays.$get({ query: { year: String(year) } })).then(
        ({ items }) => items,
      ),
  });

/** Settings › Holidays: the year's days and the region they were last filled from. */
export const holidayYearQuery = (year: number) =>
  queryOptions({
    queryKey: ["holidays", year, "with-region"],
    queryFn: () => unwrap(api.holidays.$get({ query: { year: String(year) } })),
  });
